export const SHOP_ID = 139484;
export const SC_ID = 101866;



// WEBPACK FOOTER //
// ./src/constants/payments.js